import { Injectable } from '@angular/core';
import { ObjectState, StatefullValue } from '@meddev/fe-shared';
import { Action, Selector, State, StateContext, StateToken } from '@ngxs/store';
import { ApplicationType } from '@shared/core';
import { Observable, of, tap } from 'rxjs';
import { McaAppStateModel } from './mca-app-state.model';
import { McaAppActions } from './mca-app.actions';

const MCA_APP_STATE_TOKEN = new StateToken<McaAppStateModel>('McaAppState');

const DEFAULT_STATE: McaAppStateModel = {
    styleUrl: { state: ObjectState.UNINIT, value: null },
};

@State<McaAppStateModel>({
    name: MCA_APP_STATE_TOKEN,
    defaults: DEFAULT_STATE,
})
@Injectable()
export class McaAppState {
    @Selector([MCA_APP_STATE_TOKEN])
    public static styleUrl$(state: McaAppStateModel): StatefullValue<string | null> {
        return state.styleUrl;
    }

    @Selector([MCA_APP_STATE_TOKEN])
    public static applicationType$(state: McaAppStateModel): ApplicationType | undefined {
        return state.applicationType;
    }

    @Action(McaAppActions.SetStyle)
    public setStyle$(ctx: StateContext<McaAppStateModel>, action: McaAppActions.SetStyle): Observable<StatefullValue<string | null>> {
        return of(action.styleUrl).pipe(tap(() => ctx.patchState({ styleUrl: action.styleUrl })));
    }

    @Action(McaAppActions.SetApplicationType)
    public setApplicationType$(ctx: StateContext<McaAppStateModel>, action: McaAppActions.SetApplicationType): Observable<ApplicationType> {
        return of(action.applicationType).pipe(tap(() => ctx.patchState({ applicationType: action.applicationType })));
    }
}
